<div class="container">
  <div class="own-nav row align-items-start fixed-top absolute-top" [ngClass]="{'super-user-header': superUser}">
    @if (authenticated) {
    <div class="left-group" style="z-index:1000;padding-left:20px;">
      <ul class="navbar-nav">
        <li class="nav-item dropdown" (mouseleave)="closeMenu()">
          <button data-testid="menu-toggle" tabindex="0" style="fill: white" class="main-link nav-link dropdown-toggle" id="dropdown01"
            (click)="toggleMenu($event)" [attr.aria-expanded]="isMenuOpen" aria-label="menu expand button">
            <svg fill="inherit" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="inherit" fill-rule="evenodd">
                <path fill="inherit"
                  d="M6 6h2v2H6V6zm0 5h2v2H6v-2zm0 5h2v2H6v-2zm5-10h2v2h-2V6zm0 5h2v2h-2v-2zm0 5h2v2h-2v-2zm5-10h2v2h-2V6zm0 5h2v2h-2v-2zm0 5h2v2h-2v-2z" />
              </g>
            </svg>
          </button>
          <ul class="dropdown-menu" [class.show]="isMenuOpen" [class.super-user-menu]="superUser">
            <li>
              @if (haveIncompleteTraining && isInLibrary) {
              <a class="dropdown-item" href="#" (click)="returnToTraining(); closeMenu()">Return to training</a>
              }
            </li>
            <li>
              @if (hrUser && !HRview) {
              <a class="dropdown-item" href="#" (click)="hrView(); closeMenu()">HR view</a>
              }
            </li>
            <li>
              @if (superUser) {
              <a class="dropdown-item" [routerLink]="['/client']" (click)="closeMenu()">Admin view</a>
              }
            </li>
            @if (!hrUser && !isInLibrary) {
            <li>
              <a data-testid="menu-content-library" class="dropdown-item" [routerLink]="['/library']" (click)="closeMenu()">Content Library</a>
            </li>
            }
            <li>
              <a class="dropdown-item" [routerLink]="['/terms-of-use']" target="_blank" (click)="closeMenu()">Terms of
                Use</a>
            </li>
            <li>
              <a class="dropdown-item" href="https://www.raretechnology.com/privacy-policy/" target="_blank"
                (click)="closeMenu()">Privacy
                Policy</a>
            </li>
            <li><a data-testid="menu-logout" class="dropdown-item" href="#" (click)="$event.preventDefault(); onLogout(); closeMenu()">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
    }

    @if (superUser) {
    <div class="col super-user-toolbar">
      <div class="menu">
        <div class="toolbar">
          <a (click)="gotoClient()"
            [class.active]="isRouteActive('/client') && !router.url.includes('_ALL_') && !router.url.includes('/code') && !router.url.includes('/user')">
            <mat-icon class="nav-icon">domain</mat-icon> Clients
          </a>
          <a (click)="gotoCodes()"
            [class.active]="router.url.includes('/code') && (!router.url.includes('/code/') || router.url.includes('/code/all'))">
            <mat-icon class="nav-icon"
              style="width:28px;font-size: 28px;line-height: 28px;height:28px;margin-right:10px;">abc</mat-icon> Codes
          </a>
          <a (click)="gotoTemplates()" [class.active]="router.url.includes('/template')">
            <mat-icon class="nav-icon">dashboard_customize</mat-icon> Templates
          </a>
          <a (click)="gotoContent()"
            [class.active]="router.url.includes('/content') || (router.url.includes('/code/') && !router.url.includes('/code/all'))">
            <mat-icon class="nav-icon">description</mat-icon> Contents
          </a>
          <a (click)="gotoUsers()" [class.active]="router.url.includes('/user')">
            <mat-icon class="nav-icon">people</mat-icon> Users
          </a>
          <a (click)="gotoQuestions()" [class.active]="isRouteActive('/feedback-questions')">
            <mat-icon class="nav-icon">help_outline</mat-icon> Questions
          </a>
          <a (click)="gotoTags()" [class.active]="isRouteActive('/tags')">
            <mat-icon class="nav-icon">label</mat-icon> Tags
          </a>
          <div class="reports-dropdown" (mouseleave)="onReportsMouseLeave()" (mouseenter)="onReportsMouseEnter()">
            <a (click)="toggleReportsMenu($event)"
              [class.active]="(router.url.includes('/client/_ALL_') && !router.url.includes('/user')) || isRouteActive('/monitor') || router.url.includes('/shared-reflections') || router.url.includes('/adhoc-report')">
              <mat-icon class="nav-icon">assessment</mat-icon> Reports
            </a>
            @if (showReportsMenu) {
            <div class="reports-menu">
              <a (click)="fullClientReport()" [class.active]="router.url.includes('/client/_ALL_/report')">All Client
                Completion</a>
              <a (click)="fullActionsReport()" [class.active]="router.url.includes('/client/_ALL_/actions')">All Client
                Action</a>
              <a (click)="monitorReport()" [class.active]="isRouteActive('/monitor')">Monitor</a>
              <a (click)="gotoReflections(0)" [class.active]="router.url.includes('/shared-reflections')">Feedback &
                Reflection</a>
              <a (click)="adhocReport()" [class.active]="router.url.includes('/adhoc-report')">Adhoc Reports</a>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    }
    @if (hrUser) {
    <div [ngClass]="{'col-10': authenticated, 'col-12': !authenticated, 'text-center': true}"
      style="flex:1;max-width:100%;">
      <img style="height:30px;margin-top:10px;" src="assets/img/hemisphere-logo-white.png" />
    </div>
    }
  </div>
</div>
